export interface IException {
  osdNumber?: number;
  osdType?: string;
  entryDate?: string;
  proNumber?: number;
  origin?: string;
  destination?: string;
  reporting?: string;
  commodity?: string;
  description?: string;
  totalValue?: number;
  valueRange?: string;
  manifest?: number;
  trailer?: string | number;
  investigationStatus?: string;
  lastConfirmedManifest?: string | number;
  entryBy?: string;
  od400ProNumber?: number;
  assignedTo?: string;
  assignedToName?: string;
  assignedBy?: string;
  assignedByName?: string;
  misdeliveredPalletPro?: number;
  misdeliveredBolPro?: number;
  pickupNumber?: number;
  driverName?: string;
  dockWorkerName?: string;
}
export interface IExceptionList {
  data: IException[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface IOsdDisposition {
  proNumber: string;
  osdType?: string;
  consigneeName: string;
  pickupDate?: string;
  shipperName: string;
  shipperAddress1: string;
  shipperAddress2: string;
  shipperCity: string;
  shipperState: string;
  shipperZip: string;
  consigneeAddress1: string;
  consigneeAddress2: string;
  consigneeCity: string;
  consigneeState: string;
  consigneeZip: string;
  pieces: string;
  weight: string;
  poNumber: string;
  blNumber: string;
  snNumber: string;
  dateOfRefusal?: string;
  reasonForRefusal: string;
}

export interface IOsdDetails {
  osdNumber?: number;
  osdType?: string;
  origin?: string;
  destination?: string;
  proNumber?: number;
  trailer?: string;
  manifest?: number;
  entryDate?: string;
  entryTime?: string;
  entryBy?: string;
  totalValue?: number;
  totalPieces?: number;
  hazmat?: string;
  shipperName?: string;
  shipperAddress1?: string;
  shipperAddress2?: string;
  shipperAddress?: string;
  shipperCity?: string;
  shipperState?: string;
  shipperZip?: string;
  consigneeName?: string;
  consigneeAddress1?: string;
  consigneeAddress2?: string;
  consigneeAddress?: string;
  consigneeCity?: string;
  consigneeState?: string;
  consigneeZip?: string;
  od400Completed?: string;
  od400ProNumber?: number;
  od400Manifest?: number;
  od400WhereFound?: string;
  od400Trailer?: string;
  od400Bay?: string;
  blNumber?: string;
  poNumber?: string;
  snNumber?: string;
  commodity?: string;
  package?: string;
  pieces?: number;
  weight?: number;
  numberOfPallets?: number;
  icm?: string;
  swOk?: string;
  manufacturerBrand?: string;
  valueRange?: string;
  value1k?: number;
  handlingUnits?: number;
  remarks?: string;
  description?: string;
  regionTerminal?: string;
  lastUpdate?: string;
  lastUpdatedDate?: string;
  lastUpdatedTime?: string;
  lastInvUpdatedDate?: string;
  lastInvUpdatedTime?: string;
}

export interface IRequestParametersOsd {
  assignedBy?: string;
  destination?: string[];
  assignedTo?: string;
  commodityType?: string[];
  description?: string | null;
  entryBy?: string;
  limit?: number;
  origin?: string[];
  osdNumber?: number | null;
  osdType?: string[];
  page?: number;
  proNumber?: number | null;
  od400ProNumber?: number | null;
  reporting?: string[];
  search?: string;
  sortField?: string;
  sortOrder?: "asc" | "desc" | "ASC" | "DESC" | null;
  status?: string[];
  values?: string[] | number[];
  entryDateFrom?: string;
  entryDateTo?: string;
}

export interface ICheckDigitPro {
  origin?: string;
  destination?: string;
  shipper?: string;
  shipperAccount?: string;
  shipperAddress?: string;
  shipperAddress1?: string;
  shipperAddress2?: string;
  shipperCity?: string;
  shipperState?: string;
  shipperZip?: string;
  consignee?: string;
  consigneeAccount?: string;
  consigneeAddress?: string;
  consigneeAddress1?: string;
  consigneeAddress2?: string;
  consigneeCity?: string;
  consigneeState?: string;
  consigneeZip?: string;
  thirdPartyName?: string;
  thirdPartyAddress1?: string;
  thirdPartyAddress2?: string;
  thirdPartyCity?: string;
  thirdPartyState?: string;
  thirdPartyZip?: string;
  ilScac?: string;
  manifestNumber?: number;
}


export enum CommonStatus {
  exceptionEntry = 1,
  pendingMgrApproval = 10,
  investigationComplete = 11,
  inProgress = 13,
  needsCleared = 12,
}
export enum OverageStatus {
  exceptionEntry = CommonStatus.exceptionEntry, // NOSONAR
  inProgress = CommonStatus.inProgress, // NOSONAR
  investigationComplete = CommonStatus.investigationComplete, // NOSONAR
}

export enum BillNoFreightStatus {
  exceptionEntry = CommonStatus.exceptionEntry, // NOSONAR
  needsCleared = CommonStatus.needsCleared, // NOSONAR
}

export enum RefusalStatus {
  exceptionEntry = CommonStatus.exceptionEntry, // NOSONAR
  inProgress = CommonStatus.inProgress, // NOSONAR
  followupInProgress = 14,
  needsCleared = CommonStatus.needsCleared, // NOSONAR
}

export enum ShortagesStatus {
  exceptionEntry = CommonStatus.exceptionEntry, // NOSONAR
  day1InProgress = 2,
  day2InProgress = 3,
  day3InProgress = 4,
  day4InProgress = 5,
  day5InProgress = 6,
  day10InProgress = 7,
  day15InProgress = 8,
  day20InProgress = 9,
  pendingMgrApproval = CommonStatus.pendingMgrApproval, // NOSONAR
  investigationComplete = CommonStatus.investigationComplete, // NOSONAR
}

export enum OnHandDeliveryStatus {
  exceptionEntry = CommonStatus.exceptionEntry, // NOSONAR
  inProgress = CommonStatus.inProgress, // NOSONAR
  pendingMgrApproval = CommonStatus.pendingMgrApproval, // NOSONAR
  needsCleared = CommonStatus.needsCleared, // NOSONAR
}

export enum MisDeliveryStatus {
  exceptionEntry = CommonStatus.exceptionEntry, // NOSONAR
  inProgress = CommonStatus.inProgress, // NOSONAR
  hazmatPending = 15,
  investigationComplete = CommonStatus.investigationComplete, // NOSONAR
   bolGenerated = 16,
}